<template>
  <span>
    <b-btn :id="id" ref="theButton" size="sm" class="rounded the-button" :variant="variant" :to="to">
      <span class="h4 icon" :class="icon"></span>
    </b-btn>
    <b-tooltip placement="top" :target="id" :title="tooltip" :container="id"></b-tooltip>
  </span>
</template>

<style scoped>
.btn.the-button {
  padding-top: 4px;
  padding-left: 5px;
  padding-right: 4px;
  padding-bottom: 0px;
  cursor: pointer !important;
  white-space: nowrap;
}
</style>

<script>
export default {
  props: {
    to: { type: [String, Object], required: false },
    variant: { type: String, required: false, default: 'outline-border' },
    icon: { type: String, required: false, default: 'icon-Settings' },
    tooltip: { type: String, required: false }
  },
  computed: {
    hasTooltip () {
      return this.tooltip
    },
    id () {
      return 'tooltip-button-' + this._uid
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/IconButton.vue